import { Reveal, SectionTag } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Onboarding & Vision Sync",
    desc: "We dig into your brief, audience and style references, and lock the creative direction before a single cut.",
  },
  {
    n: "02",
    title: "Assets & Storyboard",
    desc: "Raw footage lands on our high-speed ingest, and the edit is laid out frame by frame for your sign-off.",
  },
  {
    n: "03",
    title: "The Cut & Animation",
    desc: "Editing, motion graphics, SFX and color grade — built in parallel by specialists, reviewed by a project lead.",
  },
  {
    n: "04",
    title: "Review & Master Delivery",
    desc: "Frame-accurate review rounds, then final master exported in every format you need — 4K to vertical.",
  },
];

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-32 bg-[#F7F7F8] border-y border-gray-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-14">
          <SectionTag>The Pipeline</SectionTag>
          <h2 className="font-display font-extrabold text-gray-900 text-3xl md:text-5xl tracking-tight mt-4">
            Brief to master, <span className="text-crimson">four moves.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.09}>
              <div className="group relative h-full rounded-3xl border border-gray-100 bg-white shadow-soft p-8 card-hover" data-testid={`process-step-${s.n}`}>
                <div className="font-mono text-4xl font-bold text-transparent" style={{ WebkitTextStroke: "1px rgba(255,42,59,0.6)" }}>
                  {s.n}
                </div>
                <h3 className="font-display font-bold text-gray-900 text-lg mt-6 leading-snug">{s.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mt-3">{s.desc}</p>
                {i < 3 && <span className="hidden lg:block absolute top-12 -right-3.5 w-6 h-px bg-crimson/40" />}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
